import * as geoJsonUtils from "common/geoJsonUtils";
import { useMapLayerToggleControl, useHideShowMapLayer } from "./_hooks";

export default function UnassignedLandLayerToggle({ mapData, mapId }) {
    const layerId = geoJsonUtils.LAYER.UnassignedLand;
    const showLayer = useMapLayerToggleControl(mapData, mapId, layerId);
    useHideShowMapLayer(mapData, layerId, showLayer);
    return null;
}
